// extracted by mini-css-extract-plugin
export default {"table":"imvResults_table__CLHwt","row":"imvResults_row__U606g","head":"imvResults_head__bYJH-"};